const apiURL = "https://ese-at-a-glance-api.cyclic.app/";
// const apiURL = "http://localhost:5501/";
export default apiURL;
